import { Component, OnInit } from '@angular/core';
import { BookingModel, CustomersService, FindCustomerResult, UpdateVehicle, BookingService } from 'src/app/Api_Module';
import { QuoteModel, PriceModel } from 'src/app/Api_Module/model/models';
import { ToastrService } from 'ngx-toastr';
import { bookingServices, titles } from 'src/app/models/constants.model';
import { Booking, BookingQuote } from 'src/app/models/booking.model';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as uuid from 'uuid';
import { isDateRangeValid } from 'src/app/utils/utils';

declare var $: any;


@Component({
  selector: 'crg-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  times: string[] = [];
  booking: BookingModel;
  searchLoading: boolean;
  showCustDet: boolean;
  bookingServices: any[];
  titles: any[];
  dropTime: number;
  pickupTime: number;
  pricing: PriceModel;
  mindate: NgbDateStruct = {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate()};

  constructor(private customersService: CustomersService, private bookingService: BookingService, private toastr: ToastrService,
    private router: Router) { }

  ngOnInit() {
    this.bookingServices = bookingServices;
    this.booking = new Booking();
    this.booking.checkIn = new Date();
    this.booking.checkout = new Date();
    this.booking.checkout.setDate(this.booking.checkout.getDate() + 1);
    this.dropTime = this.booking.checkout.getHours();
    this.pickupTime = this.booking.checkout.getHours();
    this.booking.service = null;
    this.booking.title = null;
    this.titles = titles;
    for (let t = 0; t < 24; t++) {
      this.times.push(t.toString());
    }

    $(document).ready(function () {
      $('.partner-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      });
    });
  }

  getMinDateForCollection(): NgbDateStruct {
    const dropOffDate = !!this.booking.checkIn ? this.booking.checkIn : new Date();
    this.booking.checkout.setMinutes(0, 0, 0);
    this.booking.checkIn.setMinutes(0, 0, 0);
    if (this.booking.checkout.getTime() <  dropOffDate.getTime()) {
      this.booking.checkout = dropOffDate;
    }
    return {year: dropOffDate.getFullYear(), month: dropOffDate.getMonth() + 1, day: dropOffDate.getDate()};
  }
  convertUTCDateToLocalDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }
  getTimesForCollection(): string[] {
    const times = [... this.times];
    // const dropOffDate = !!this.booking.checkIn ? this.booking.checkIn : new Date();
    // if (this.booking.checkIn.getTime() ===  this.booking.checkout.getTime()) {
    //   times.splice(0, this.booking.checkIn.getHours() + 1);
    // }
    return times;
  }

  getQuote(): void {
    if (!isDateRangeValid(this.booking.checkIn, this.dropTime, this.booking.checkout, this.pickupTime)) {
      this.toastr.warning('Invalid Range, Drop-Time should be before Pick-Up Time');
      return;
    }
    console.log(this.dropTime);
    console.log(this.pickupTime);
    this.searchLoading = true;
    this.booking.checkIn.setHours(0, (this.dropTime * 60), 0, 0);
    this.booking.checkIn = this.convertUTCDateToLocalDate(this.booking.checkIn);
    this.booking.checkout.setHours(0, (this.pickupTime * 60), 0, 0);
    this.booking.checkout = this.convertUTCDateToLocalDate(this.booking.checkout);
    const quote: QuoteModel = {
      checkIn: this.booking.checkIn,
      checkout: this.booking.checkout,
    };

    this.bookingService.quote(quote).subscribe((resp: PriceModel) => {
      this.pricing = resp;
      this.showCustDet = true;
      this.searchLoading = false;
      const sdate = new Date();
      const expDate = new Date(sdate.getTime());
      expDate.setHours(sdate.getHours() + 24);
      this.storeQuote({ booking: this.booking, price: this.pricing, date: sdate, expDate: expDate, id: uuid.v4()});
    }, error => {
      if (error['status'] === 404) {
        this.showCustDet = true;
      } else {
        this.toastr.error('Something went wrong, please try again later.');
      }
      this.searchLoading = false;
    });
  }
  book(): void {
    this.router.navigate(['/home']);
  }

  storeQuote(quote: BookingQuote) {
    let recentQuotes = [];
    if (!!localStorage.getItem('recentQuotes')) {
      recentQuotes = JSON.parse(localStorage.getItem('recentQuotes'));
    }
    recentQuotes.push(quote);
    localStorage.setItem('recentQuotes', JSON.stringify(recentQuotes));
  }


}
